export default __webpack_public_path__ + "static/media/HomeSite_Icon.caa546ce.svg";